module.exports = __webpack_public_path__ + "img/Dantam Fashion 10.40c18526.jpg";